// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./components/shared/AuthContext";
import { RoleProvider } from "./components/shared/RoleContext";
import "./index.css";
import "./App.css";

const container = document.getElementById("root");
// createRoot replaces ReactDOM.render in React 18+
const root = createRoot(container);

root.render(
  <AuthProvider>
    <RoleProvider>
      <App />
    </RoleProvider>
  </AuthProvider>
);
